import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
    createStyles({

        //テーブルヘッダセル
        headerCell: {
            padding: '2px',
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            backgroundColor: 'grey',
            textAlign: 'center',
            color: 'white',
            minWidth: '80px',
            borderCollapse: `collapse`,
        },
        bodyCell: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            padding: '1px',
            height: '35px',
        },
        bodyCellCenter: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            textAlign: 'center',
            padding: '1px',
            height: '30px',
        },
        bodyCellLeft: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            padding: '1px',
            height: '30px',
            extAlign: 'Left',
        },
        labelStyle: {
            fontSize: '12px',
        },
        itemBoxStyle: {
            fontSize: '13px',
        },
        bodyRow: {
            '&.Mui-selected, &.Mui-selected:hover': {
                //背景色
                backgroundColor: 'yellow',
                '& > .MuiTableCell-root': {
                    //文字色
                    color: 'brack',
                },
            },
        },
        tableTd: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            padding: '0px',
            paddingLeft: '5px',
            borderCollapse: `collapse`,
            zIndex: 0,
        },
        //テキスト
        textField: {
            flexGrow: 1,
            height: '100%',
            width: '98%',
            border: 'none',
            backgroundColor: 'transparent',
            textAlign: "center",
        },
        fixColumn: {
            borderWidth: '0px',
            outlineWidth: '1px',
            outlineColor: '#dcdcdc',
            outlineStyle: 'solid',
            padding: '0px',
            paddingLeft: '5px',
            position: 'sticky',
            zIndex: 10,
            backgroundColor: 'white',
        },
        logTimeField: {
            paddingLeft: "2px",
            width: '24px',
        },
        tableContainer: {
            maxHeight: 'calc(100vh - 310px)',
            overflowX: 'scroll',
        },
        flexBox: {
            dispay: "flex",
        },
        tableDialgContainer: {
            maxHeight: 'calc(100vh - 276px)',
        },
        paper: {
            background: '#FFFFEE',
        },
        buttonStyle: {
            maxWidth: '180px',
            maxHeight: '35px',
            minWidth: '180px',
            minHeight: '35px',
        },
        fixHeader: {
            color: 'white',
            borderWidth: '0px',
            backgroundColor: 'gray',
            outlineWidth: '1px',
            outlineColor: '#dcdcdc',
            outlineStyle: 'solid',
            padding: 0,
            margin: 0,
            textAlign: 'center',
            position: 'sticky',
            zIndex: 20,
            minWidth: '80px',
            borderCollapse: `collapse`,
        },
        selectRow: {
            background: 'yellow',
        },
    })
);